
const trainings = '/trainings'

export const paths = {
    trainings: {
        root: trainings,
        student: {
            profile: `${trainings}/profile`
        },
        program: `${trainings}/program`,
        classes: `${trainings}/sessions`,
        trainers: `${trainings}/trainers`,
        counselors: `${trainings}/counselors`,
        students: `${trainings}/students`,
        studentsNew: `${trainings}/students/new`,
        payments: `${trainings}/payments`,
        fee: `${trainings}/fee-management`

    }
}